module.exports = __webpack_public_path__ + "img/pro.4393142f.jpg";